<template>
    <div class="wrapper">
        <v-head></v-head>
        <v-sidebar></v-sidebar>
        <div class="content-box" :style="isPaddingBottom ? 'padding-bottom: 30px':''" :class="{'content-collapse':collapse, 'content-fullbox':!FullScreenShow}">
            <!-- <v-tags></v-tags> -->
            <tags-view />
            <div class="content">
              <!-- 菜单权限 -->
              <transition name="move" mode="out-in">
                <keep-alive :include="cachedViews">
                  <router-view :key="key"></router-view>
                </keep-alive>
              </transition>

              <!-- 暂无权限遮罩 -->
              <div v-if="hasPermission" class="permissions-mask">
                <img src="../assets/images/no-permissions.png" alt="">
                <p>暂无数据权限，请联系管理员~</p>
              </div>
              <el-backtop target=".content"></el-backtop>
            </div>
        </div>
    </div>
</template>

<script>
import vHead from './Header.vue'
import vSidebar from './Sidebar.vue'
import tagsView from './TagsView'
// import vTags from './Tags.vue'
import user from '../store/user/index'
import toggle from '../store/toggle/index'

// import bus from './bus'
export default {
  data () {
    return {
      tagsList: [],
      collapse: false,
      isPaddingBottomList: ['/goodsmanage/goodsedit/view', '/liquidationManage/liquidationLossDetail']
    }
  },
  components: {
    vHead,
    vSidebar,
    tagsView
  },
  computed: {
    cachedViews () {
      return this.$store.state.tagsView.cachedViews
    },
    key () {
      return this.$route.path
    },
    userinfo () {
      return user.state.userinfo
    },
    // 1级菜单
    firstMenu () {
      return `/${this.key.split('/')[1]}/`
    },
    // 是否显示暂无权限遮罩
    hasPermission () {
      let url = '["//","/systemConfig/","/waremanage/"]' // 1级目录
      if (url.indexOf(this.firstMenu) > -1) {
        return false
      }
      return this.identity === '4' && !this.userinfo.warehouseCode && (!this.userinfo.warehouseCodes || !this.userinfo.warehouseCodes.length)
    },
    silderToggle () {
      return toggle.state.sliderToggle
    },
    // 是否开启全屏
    FullScreenShow () {
      return user.state.FullScreenShow
    },
    isPaddingBottom () {
      let flag = false
      for (let i = 0; i < this.isPaddingBottomList.length; i++) {
        if (this.key === '/' || this.key.indexOf(this.isPaddingBottomList[i]) > -1) {
          flag = true
        }
      }
      return flag
    },
    // 1商户 2供应商 3SAAS人员 4商户并且部门在一级
    identity () {
      return localStorage.getItem('identity')
    }
  },
  created () {
    // bus.$on('collapse-content', msg => {
    //   this.collapse = msg
    // })

    // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
    // bus.$on('tags', msg => {
    //   let arr = []
    //   for (let i = 0, len = msg.length; i < len; i++) {
    //     msg[i].name && arr.push(msg[i].name)
    //   }
    //   this.tagsList = arr
    // })
  }
}
</script>
<style>
@import '../style/main.css';
</style>
<style scoped>
  .permissions-mask{
    background: #666;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    position: absolute;
    top: 40px;
    left: 10px;
    right: 0;
    bottom: 0px;
    z-index: 99;
  }
  .permissions-mask > p {
    margin-top: 50px;
    font-size: 22px;
  }
</style>



// WEBPACK FOOTER //
// src/layout/index.vue